import React from "react";

const AboutMeBody = ({ language = "en", body = "" }) => {
  const dir = language === "ar" ? "rtl" : "ltr";
  const textAlign = language === "ar" ? "text-right" : "text-left";

  // Split the API text into paragraphs on blank lines
  const paragraphs = String(body)
    .replace(/\r\n/g, "\n")
    .split(/\n\s*\n/) // split on double newlines (with optional spaces)
    .filter(Boolean);

  return (
    <div className="about-me-body" dir={dir}>
      <div className="container">
        <div className="about-me-divider"></div>
        {paragraphs.map((para, index) => (
          <p key={index} className={textAlign}>
            {para}
          </p>
        ))}
      </div>
    </div>
  );
};

export default AboutMeBody;
